import { getFormValues, change } from 'redux-form';
import _get from 'lodash/get';
import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';
import {createSelectOptionsFromSysEnums} from '../../../shared/form-elements/select';

const FEATURE_FLAGS_FORM_SUBMIT_SUCCESS = 'affiliateEdit/FEATURE_FLAGS_FORM_SUBMIT_SUCCESS';
const FEATURE_FLAGS_FORM_SUBMIT_ERROR = 'affiliateEdit/FEATURE_FLAGS_FORM_SUBMIT_ERROR';

const LOCATION_LOOKUP_FETCH_SUCCESS = 'affiliateEdit/LOCATION_LOOKUP_FETCH_SUCCESS';
const LOCATION_LOOKUP_FETCH_ERROR = 'affiliateEdit/LOCATION_LOOKUP_FETCH_ERROR';

const TOGGLE_PROGRESS_BAR = 'affiliateEdit/toggle-progress-bar';

// initial state
const initialState = {
	feature_flags_JSON: null,
	antiduble_rules: null
};

// actions
const actions = {
	submitFeatureFlagsForm: formData => (dispatch, getState) => {
		const { data: { id } } = getState().affiliateEdit;
		const request = http({
			url: `${endpoints.AFFILIATES.BASE}/${id}/feature-flags`,
			method: 'put',
			actions: [
				FEATURE_FLAGS_FORM_SUBMIT_SUCCESS,
				FEATURE_FLAGS_FORM_SUBMIT_ERROR
			],
			data: selectors.getFeatureFlagsObject(getState())
		});

		dispatch({ type: TOGGLE_PROGRESS_BAR });

		return request(dispatch).then(() => dispatch({ type: TOGGLE_PROGRESS_BAR }));
	},
	locationsLookups: text => (dispatch, getState) => {
		const request = http({
			url: `${endpoints.LOOKUPS.LOCATIONS}?query=${text}`,
			method: 'get',
			actions: [ LOCATION_LOOKUP_FETCH_SUCCESS, LOCATION_LOOKUP_FETCH_ERROR]
		});

		return request(dispatch).then(action => {
			if (action.type === LOCATION_LOOKUP_FETCH_SUCCESS) {
				const { data } = action.payload;

				return {
					options: createSelectOptionsFromSysEnums(data)
				};
			}
		});
	},
	updateFeatureFlagsJsonDelayed: 	() => dispatch => {
		setTimeout(() => dispatch(actions.updateFeatureFlagsJSON()), 200);
	},
	updateFeatureFlagsJSON: () => (dispatch, getState) => {
		const formValues = getFormValues('affiliateFeatureFlagsForm')(getState());

		const antiduble_rules = Array.isArray(formValues.antiduble_rules)
			&& formValues.antiduble_rules.map( ar => ({
				...ar,
				country_id: _get(ar, 'country_id.0.value', null),
				country_label: _get(ar, 'country_id.0.label', null)
			})
			);

		dispatch(change('affiliateFeatureFlagsForm', `feature_flags_JSON`, JSON.stringify({
			...selectors.getFeatureFlagsObject(getState()),
			antiduble_rules: antiduble_rules || null,
			is_contest_included: formValues.is_contest_included
		})));
	}
};

// reducers
const reducers = {
	[FEATURE_FLAGS_FORM_SUBMIT_SUCCESS]: (state, action) => {
		return { ...state, data: null };
	}
};

// selectors
const selectors = {
	getFeatureFlagsObject: state => JSON.parse(getFormValues('affiliateFeatureFlagsForm')(state).feature_flags_JSON),
	getCanEditFeatureFlagsManually: state =>
		getFormValues('affiliateFeatureFlagsForm')(state)
		&& getFormValues('affiliateFeatureFlagsForm')(state).can_edit_feature_flags_manually,
	getFeatureFlagsInitialData: state => {
		const antiduble_rules = _get(state, 'affiliateEdit.data.feature_flags.antiduble_rules');
		const hasAntidubleRulesArray = Array.isArray( antiduble_rules );
		const antidubleRulesMappedToForm = hasAntidubleRulesArray
			? antiduble_rules.map(ar => ({...ar, country_id: [{ value: ar.country_id, label: ar.country_label }]}))
			: null;

		return ({
			feature_flags_JSON: JSON.stringify(_get(state, 'affiliateEdit.data.feature_flags')),
			antiduble_rules: antidubleRulesMappedToForm,
			is_contest_included: !!_get(state, 'affiliateEdit.data.feature_flags.is_contest_included')
		});
	}

};

export default function createFeatureFlagsForm() {
	return { selectors, reducers, actions, initialState };
}


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/form/feature-flags.index.js